import { Button } from '@ps-design-system/components/Button';
import InfoIcon from '@ps-design-system/icons/Info/Info20';
import XIcon from '@ps-design-system/icons/X/X24';
import React from 'react';
import { FormattedNumber } from 'react-intl';
import BootstrapModal from 'shared-components/modal/bootstrap-modal';
import { Tooltip } from 'shared-components/tooltip/tooltip';
import { CateringPackageForm } from './CateringPackageForm';

export class CateringPackageFormModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      nextBtnDisabled: true
    };
  }

  render() {
    const { cateringPackage, closeModal, onNext } = this.props;
    const { nextBtnDisabled } = this.state;

    return (
      <BootstrapModal
        {...this.props}
        modalSize="lg-size"
        modalClass="catering-menu-form-modal catering-package-form-modal"
        fixedHeaderFooter={true}
        header={
          <div className="relative">
            <h5 className="tw-headline-4 no-margin">{cateringPackage.name}</h5>
            <p className="tw-body-2 text-gray-600 no-margin">
              {cateringPackage.menu.subtext || cateringPackage.subtext}
            </p>
            {cateringPackage.price?.value > 0 && (
              <p className="tw-body-2-m no-margin">
                {cateringPackage.price.starts_at && 'Starts at '}
                <FormattedNumber
                  value={cateringPackage.price?.value}
                  currency="USD"
                  style="currency"
                  minimumFractionDigits={
                    Number.isInteger(cateringPackage.price?.value) ? 0 : 2
                  }
                  maximumFractionDigits={2}
                />{' '}
                per person
              </p>
            )}
            <Button
              className="absolute"
              style={{ top: '0', right: '0' }}
              iconOnly={true}
              variant="text-only"
              onClick={closeModal}
            >
              <XIcon />
            </Button>
          </div>
        }
        body={
          <CateringPackageForm
            cateringPackage={cateringPackage}
            onIsValidChange={(isValid) =>
              this.setState({ nextBtnDisabled: !isValid })
            }
          />
        }
        footer={
          <div className="catering-package-footer-content-wrap">
            <div className="text-gray-600 tw-body-2-m flex middle">
              Not positive on all the details just yet?
              <span className="margin-sm-left">
                <Tooltip
                  id="catering-tooltip"
                  anchorType="custom"
                  hideOnClickAnywhere={true}
                  customAnchor={<InfoIcon />}
                  anchorClickCB={({ showTooltip }) => showTooltip(true)}
                  placement="top"
                >
                  <p className="no-margin">
                    You can book now and modify your selections up to three days
                    before your event.
                  </p>
                </Tooltip>
              </span>
            </div>

            <Button onClick={onNext} disabled={nextBtnDisabled}>
              Next
            </Button>
          </div>
        }
        addCloseIcon={false}
      />
    );
  }
}
